import { useEffect, useState } from 'react';
import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectHoursSummaryWithPercentageDto } from '../../../commonTypes/timelog.types';

const useHttpGetProjectHoursSummary = (projectId: string, enabled: boolean = true) => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const [data, setData] = useState<ProjectHoursSummaryWithPercentageDto | null>(null);
    const [isReady, setIsReady] = useState(false);

    const getSummary = (projectIdd: string) => {
        if (!projectIdd) {
            setIsReady(true);
            return;
        }

        const { exec, abort } = timeLogApi.getProjectHoursSummary({
            query: { projectId: projectIdd },
            onSuccess: res => {
                setData(res.body);
                setIsReady(true);
            },
            onError: error => {
                console.error('Error fetching project hours summary:', error);
                setIsReady(true);
            },
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (!enabled) {
            setIsReady(true);
            return;
        }

        if (projectId) {
            getSummary(projectId);
        }
    }, [projectId, enabled]);

    return { data, isReady, getSummary };
};

export default useHttpGetProjectHoursSummary;
